<template>
  <div class="mains">
    <div class="main-top">
      <div class="t-left">
        <div class="l-main">
          <div class="l-title">产品服务</div>
          <div class="l-child">
            <div @click="$router.push({path: '/legalConsult'})">企业法律咨询</div>
            <div @click="$router.push({path: '/legalCourse'})">企业法务通</div>
            <div @click="$router.push({path: '/legalDepartment'})">企业法务部</div>
          </div>
        </div>
        <div class="l-main">
          <div class="l-title">关于弘商</div>
          <div class="l-child">
            <div @click="$router.push({path:'/companyProfile'})">公司介绍</div>
            <div @click="$router.push({path:'/dynamicInformation'})">动态资讯</div>
            <div @click="$router.push({path:'/joinUs'})">加入我们</div>
          </div>
        </div>
        <div class="l-main">
          <div class="l-title">帮助中心</div>
          <div class="l-child">
            <div @click="$router.push({name: 'help',params:{type:0}})">常见问题</div>
            <div @click="$router.push({name: 'help',params:{type:1}})">反馈</div>
            <div>下载app</div>
            <div @click="$router.push({name: 'help',params:{type:2}})">联系我们</div>
          </div>
        </div>
        <div class="l-main">
          <div class="l-title">服务平台</div>
          <div class="l-child">
            <div>我是律师</div>
            <div>我是企业</div>
          </div>
        </div>
      </div>
      <div class="t-right">
        <div class="r-phone">
          <img src="/static/img/phone1.png" class="r-img">
          <div>0755-8254 7304</div>
        </div>
        <div class="r-wechat">
          <div class="wechat">
            <div v-viewer="{ 'navbar': false, 'toolbar': false, 'rotatable': false, 'scalable': false, 'keyboard': true}">
              <img src="/static/img/qrcode1.png" title="点击放大" class="wechat-img">
            </div>
            <div>更多法律服务</div>
          </div>
          <div class="wechat">
            <div v-viewer="{ 'navbar': false, 'toolbar': false, 'rotatable': false, 'scalable': false, 'keyboard': true}">
              <img src="/static/img/wechat1.png" title="点击放大" class="wechat-img">
            </div>
            <div>法律咨询/活动报名</div>
          </div>
        </div>
      </div>
    </div>
    <div class="main-bottom">©{{new Date().getFullYear()}} 弘商信息技术　|　<a href="https://beian.miit.gov.cn" target="_blank">粤ICP备17098295号-2</a></div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  data () {
    return {
      
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.mains
    background-color:#2751CB;
    width:100%;
    min-width: 1440px;
    height:350px;
    .main-top
      height:290px;
      display:flex;
      padding:55px; 
      // align-items:center;
      justify-content:center;
      .t-left
        display:flex;
        .l-main
          margin-right:80px;
          .l-title
            font-size:18px;
            color:#fff;
            font-weight:500;
            margin-bottom:30px;
          .l-child
            // display:flex;
            font-size:14px;
            font-weight:500;
            color:rgba(255,255,255,0.6);
            div
              margin-bottom:15px;    
              cursor:pointer;    
      .t-right
        .r-phone
          display:flex;
          align-items:center;
          color:#FFFFFF;
          font-weight:500;
          font-size:18px;
          margin-bottom:25px;
          .r-img
            width:18px;
            height:18px;
            margin-right:10px;
        .r-wechat
          display:flex;
          .wechat
            margin-right:34px;
            font-size:14px;
            font-weight:500;
            color:rgba(255,255,255,0.6);
            .wechat-img
              width:96px;
              height:96px;
              margin-bottom:6px;
              cursor:pointer;
    .main-bottom
      height:60px;
      line-height:60px;
      background-color:#1F47BA;
      font-size:12px;
      font-weight:500;
      color:#FFFFFF;
      text-align:center;
      a
        text-decoration:none;
        color:#FFFFFF !important;
      a:hover
        text-decoration:none;
        color:#FFFFFF !important;
</style>


// WEBPACK FOOTER //
// src/components/common/footer.vue